interface IPData {
	ip: string;
	city?: string;
	region?: string;
	country?: string;
}

/**
 * Fetch user's IP address and location data using a two-step API approach
 * Step 1: Get IP address from api.ipify.org
 * Step 2: Get location details from ipapi.co using the IP address
 */
export const fetchIPAndLocation = async (): Promise<IPData> => {
	try {
		// Step 1: Get IP address
		const responseIP = await fetch(
			`https://api.ipify.org/?format=json`,
		).then((res) => res.json());

		const ipAddress = responseIP?.ip;
		
		if (!ipAddress) {
			throw new Error('Could not retrieve IP address.');
		}

		// Step 2: Get system info using the IP address
		const systemInfo = await fetch(
			`https://ipapi.co/${ipAddress}/json`,
		).then((res) => res.json());

		return {
			ip: ipAddress || 'Unknown',
			city: systemInfo?.city || 'N/A',
			region: systemInfo?.region || 'N/A',
			country: systemInfo?.country_name || 'N/A',
		};
	} catch (error) {
		console.error('Error retrieving IP or system info:', error);
		return {
			ip: 'Unknown',
			city: 'N/A',
			region: 'N/A',
			country: 'N/A',
		};
	}
};

